import React from 'react';
import moment from 'moment-timezone';

import './ModalShiftDetails.scss';

const ModalShiftDetails = ({
	dateTime,
	resourceType,
	startTime,
	endTime,
	openShift,
	facilityName,
	unitName,
	isCaregiverInvite = false
}) => {
	const day = moment(dateTime).format('dddd');
	const date = moment(dateTime).format('MMM D, YYYY');
	return (
		<section className="shift-details-container modal-actions">
			<div className="shift-details-header">
				<h4>
					<span>Shift Details</span>
				</h4>
			</div>
			{facilityName && (
				<div className="shift-details-row">
					<p>
						Facility: <b>{facilityName}</b>
					</p>
				</div>
			)}
			<div className="shift-details-body">
				<div className="shift-details-row">
					<p>
						Date: <span>{day}, </span>
						<b>{date}</b>
					</p>
					<p>
						Shift Type: <b>{resourceType}</b>
					</p>
				</div>
				<div className="shift-details-row">
					<p>
						Time: <b>{`${startTime} - ${endTime}`}</b>
					</p>
					<p>
						Open Shifts: <b>{openShift}</b>
					</p>
				</div>
				{!isCaregiverInvite && (
					<div className="shift-details-row">
						<p className="full">
							Unit: <strong>{unitName ?? '-'}</strong>
						</p>
					</div>
				)}
			</div>
		</section>
	);
};

export default ModalShiftDetails;
